export default __webpack_public_path__ + "static/media/longchampmini.50f55d87.jpg";